import { render, staticRenderFns } from "./TabNavigationPanel.vue?vue&type=template&id=15cddb1e&"
import script from "./TabNavigationPanel.vue?vue&type=script&lang=js&"
export * from "./TabNavigationPanel.vue?vue&type=script&lang=js&"
import style0 from "./TabNavigationPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports